<template>
  <Modal v-model="openForm" :title="title" footer-hide fullscreen
    ><Form ref="item" :model="item" :rules="ruleValidate" :label-width="80">
      <Row :gutter="16">
        <Col span="6" v-for="(x, index) in forms" :key="index">
          <FormItem :label="x.title" :prop="x.key1">
            <Input
              v-if="x.type == 'Input'"
              v-model="item[x.key]"
              placeholder="请输入"
            ></Input>
            <lyyymmdd
              v-if="x.type == 'lyyymmdd'"
              v-model="item[x.key]"
            ></lyyymmdd>
            <InputNumber
              v-if="x.type == 'InputNumber'"
              :max="99"
              :min="1"
              v-model="item[x.key]"
              style="width: 100%"
            ></InputNumber>
            <Select
              v-model="item[x.key]"
              style="width: 100%"
              v-if="x.type == 'Select'"
            >
              <Option
                :value="y"
                v-for="(y, index1) in selects[x.key]"
                :key="index1"
                :label="y"
              >
                <span>{{ y }}</span>
              </Option>
            </Select>
            <Select
              v-model="item[x.key]"
              style="width: 100%"
              v-if="x.type == 'Select1'"
            >
              <Option
                :value="index1"
                v-for="(y, index1) in $t(x.selectKey)"
                :key="index1"
                :label="y"
              >
                <span>{{ y }}</span>
              </Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Table id="lytable" border :columns="columns" :data="tableData"
        ><div style="padding: 10px 0" slot-scope="{ row, index }" slot="aaaa">
          <CheckboxGroup v-model="tableData[index].aaaa">
            <Checkbox
              :label="y"
              v-for="(y, index3) in tableData[index].fdsdsdgse"
              :key="index3"
              >{{ y }}</Checkbox
            >
          </CheckboxGroup>
        </div>
        <template slot-scope="{ row, index }" slot="bbbb">
          <Input v-model="tableData[index].bbbb"></Input>
        </template>

        <template slot-scope="{ row, index }" slot="progress">
          <Select v-model="tableData[index].progress" style="width: 100%">
            <Option
              :value="y"
              v-for="(y, index1) in progresses"
              :key="index1"
              :label="y"
            >
              <span>{{ y }}</span>
            </Option>
          </Select>
        </template>
      </Table>
      <Row type="flex" justify="end">
        <Col span="24">
          <div class="btn-wrap">
            <Button type="primary" @click="save('item')">提交表单</Button>
          </div>
        </Col>
      </Row>
    </Form>
  </Modal>
</template>
<script>
import fields from "./fields";
export default {
  data() {
    return {
      openForm: false,
      ruleValidate: {},
      item: {
        inspectId: "",
        item: "路基边坡、防护",
        time: Date.now(),
        type: "2",
        content: "",
        name: "",
        remark: "",
      },
      forms: [],
      selects: {
        unit: ["工日", "台班"],
        item: ["路基边坡、防护", "待定选项1", "待定选项2", "待定选项3"],
      },
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "巡查内容",
          key: "content",
          width: 150,
        },
        {
          title: "巡查情况",
          slot: "aaaa",
        },
        {
          title: "病害或问题情况",
          slot: "bbbb",
          width: 150,
        },
        {
          title: "处理情况",
          slot: "progress",
          width: 150,
        },
      ],
      tableData: [
        {
          content: "路基边坡、防护",
          fdsdsdgse: ["本次未巡查", "发现病害或问题", "全线未发现问题"],
          aaaa: [],
          bbbb: "",
          progress: "未进行",
        },
        {
          content: "桥面行车道",
          fdsdsdgse: [
            "本次未巡查",
            "病害",
            "障碍物",
            "设备故障",
            "保护区域范围作业",
            "结构明显异常",
            "出现电器设备运营状况",
            "其他不安全因素",
            "全线未发现问题",
          ],
          aaaa: [],
          bbbb: "",
          progress: "未进行",
        },
        {
          content: "沿线排水设施",
          fdsdsdgse: ["本次未巡查", "发现病害或问题", "全线未发现问题"],
          aaaa: [],
          bbbb: "",
          progress: "未进行",
        },
        {
          content: "沿线机电设施",
          fdsdsdgse: ["本次未巡查", "发现病害或问题", "全线未发现问题"],
          aaaa: [],
          bbbb: "",
          progress: "未进行",
        },
        {
          content: "沿线安全设施",
          fdsdsdgse: ["本次未巡查", "发现病害或问题", "全线未发现问题"],
          aaaa: [],
          bbbb: "",
          progress: "未进行",
        },
        {
          content: "沿线绿化",
          fdsdsdgse: ["本次未巡查", "发现病害或问题", "全线未发现问题"],
          aaaa: [],
          bbbb: "",
          progress: "未进行",
        },
        {
          content: "桥下空间",
          fdsdsdgse: ["本次未巡查", "发现病害或问题", "全线未发现问题"],
          aaaa: [],
          bbbb: "",
          progress: "未进行",
        },
        {
          content: "其他",
          fdsdsdgse: ["本次未巡查", "发现病害或问题", "全线未发现问题"],
          aaaa: [],
          bbbb: "",
          progress: "未进行",
        },
      ],
      title: "",
      progresses: ["已完成", "未进行"],
    };
  },
  methods: {
    reach(v) {
      this.openForm = true;
      this.forms = fields[v.key];
      this.item.inspectId = v.docId;
      this.rule();
      this.title = v.name;
    },
    save(name) {
      //this.item.time = this.utils.toSjc(this.item.time1);
      this.item.content=JSON.stringify(this.tableData);
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-rmm-server-dpm/inspect/execution/add",
            data: this.item,
          }).then((res) => {
            if (res) {
              this.openForm = false;
              this.$Message.success("提交成功");
            }
          });
        }
      });
    },
    check(name) {
      this.aaaaaa = false;
      this.$refs[name].validate((valid) => {
        this.aaaaaa = valid;
        if (!valid) {
          alert(this.title + "未完善");
        }
      });
    },
    readCheck() {
      this.check("item");
      return this.aaaaaa;
    },
    rule() {
      var arr = this.forms;
      var abc = {};

      for (let i = 0; i < arr.length; i++) {
        if (arr[i].required) {
          abc[arr[i].key1] = { required: true, message: "必填" };
        }
      }
      this.ruleValidate = abc;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/yhgl/forms/nightRecord.vue